import React from "react";
import "./Buttons.css";
import { AiOutlineInfoCircle } from "react-icons/ai";
import Spacer from "./Spacer";

export function PrimaryButton(props) {
  return (
    <button
      className="base-button primary-button"
      onClick={props.action}
      style={{ ...props.style }}
    >
      {props.children}
    </button>
  );
}

export function SecondaryButton(props) {
  return (
    <button
      className="base-button secondary-button"
      onClick={props.action}
      style={{ ...props.style }}
    >
      {props.children}
    </button>
  );
}

export function TertiaryButton(props) {
  return (
    <button
      className="base-button tertiary-button"
      onClick={props.action}
      style={{ ...props.style }}
    >
      {props.children}
    </button>
  );
}

export function InfoButton(props) {
  return (
    <button
      className="info-button"
      onClick={props.action}
      style={{ ...props.style }}
    >
      <AiOutlineInfoCircle size={42} color="white" />
      <Spacer size={1} />
      <p className="info-text">{props.children}</p>
      <Spacer size={1} />
      <AiOutlineInfoCircle size={42} color="white" />
    </button>
  );
}
